import { OngoingShiftsList } from '../../../ui/features/ongoingShifts/components/OngoingShiftsList';
import { useOngoingMissionsTable } from '../../../ui/features/ongoingShifts/hooks/useOngoingMissionsTable';
import { useMissionsTranslation } from '../../../ui/hooks';
import { DataTable, defaultRowsPerPageOptions, TablePaginationContent } from '@juvare/common-data-table-ui/DataTable';
import { visuallyHidden } from '@juvare/common-form-ui/utils/visualyHidden';
import { EmptyContentWrapper } from '@juvare/common-web-ui/EmptyContentWrapper';
import { useFeatureFlag } from '@juvare/common-web-ui/hooks';
import { IconPlaceholder } from '@juvare/common-web-ui/IconPlaceholder';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import { Box, Card, List, Typography } from '@mui/material';
import React from 'react';
import { missionHeaderStyleMap } from '../mission-list/utils';
export const OngoingShifts = ({ renderFindVolunteer = () => null }) => {
    const { t } = useMissionsTranslation();
    const { dataTableProps } = useOngoingMissionsTable();
    const ongoingShiftsListFeature = useFeatureFlag('missions', 'ongoingShiftsList');
    if (!ongoingShiftsListFeature.enabled) {
        return null;
    }
    return (React.createElement(Card, { variant: 'outlined', sx: {
            p: 2,
            pb: 0,
            backgroundColor: themeColors.surface.primary,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        } },
        React.createElement(Box, { sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 2 } },
                React.createElement(IconPlaceholder, { status: 'success' },
                    React.createElement(FlagOutlinedIcon, null)),
                React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column' } },
                    React.createElement(Typography, { variant: 'subtitle2' }, "Ongoing Shift"),
                    React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle }, t('shifts.ongoingShifts.header.description')))),
            renderFindVolunteer()),
        React.createElement(DataTable, Object.assign({}, dataTableProps, { rowsPerPageOptions: [3, ...defaultRowsPerPageOptions], customTableSurfaceComponent: ({ children }) => React.createElement(Box, null, children), customTableContentComponent: (props) => (React.createElement(CustomOngoingMissionsTableContentComponent, Object.assign({}, props, { renderFindVolunteer: renderFindVolunteer }))), customTablePaginationContentComponent: (props) => React.createElement(TablePaginationContent, Object.assign({}, props)) }))));
};
const CustomOngoingMissionsTableContentComponent = (props) => {
    const { t } = useMissionsTranslation();
    const ongoingMissions = props.rows;
    if (ongoingMissions.length === 0) {
        return React.createElement(EmptyContentWrapper, { description: t('shifts.ongoingShifts.noOngoingShifts'), imageSize: 'small' });
    }
    return (React.createElement(List, { sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            p: 0,
        } }, ongoingMissions.map((row) => {
        const missionLabelId = `mission-${row.id}-label`;
        return (React.createElement(Box, { component: 'li', key: row.id, "aria-labelledby": 'mission' },
            React.createElement(Box, { id: 'mission', sx: visuallyHidden }, t('shifts.ongoingShifts.missionName', { missionName: row.columns.name })),
            React.createElement(Box, { sx: Object.assign({ display: 'flex', justifyContent: 'space-between', paddingY: 1, paddingX: 2, borderRadius: '4px 4px 0 0' }, missionHeaderStyleMap[row.columns.status]) },
                React.createElement(Typography, { id: missionLabelId, role: 'heading', variant: 'subtitle2' }, row.columns.name),
                React.createElement(Typography, { variant: 'subtitle2' }, t(`missions.status.${row.columns.status}`))),
            React.createElement(OngoingShiftsList, { missionId: row.id, missionName: row.columns.name, missionStatus: row.columns.status, renderFindVolunteer: props.renderFindVolunteer, ariaLabelledBy: missionLabelId })));
    })));
};
